// Bionic Reading Utility
function applyBionicReading(rootElement) {
  if (!rootElement) return;

  const validTags = ['P', 'SPAN', 'DIV'];

  const nodes = rootElement.querySelectorAll(validTags.join(','));

  nodes.forEach(el => {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
        const words = node.nodeValue.split(/(\s+)/).map(word => {
          if (!word.trim()) return word;
          const len = Math.ceil(word.length * 0.4);
          return `<span class="bionic"><b>${word.slice(0, len)}</b>${word.slice(len)}</span>`;
        });

        const span = document.createElement('span');
        span.innerHTML = words.join('');
        node.replaceWith(span);
      }
    });
  });
}

(function() {
    // function getFlagEmoji(countryCode) {
    //   const codePoints = countryCode
    //     .toUpperCase()
    //     .split('')
    //     .map(char =>  127397 + char.charCodeAt());
    //   return String.fromCodePoint(...codePoints);
    // }

    function getCurrentCountryCode() {
      return document.documentElement.dataset.countryCode;
    }
  
    function addShippingTime() {
      var daysAfterToday = 1; // Set this to the number of days after today that the item will ship
      var today = new Date();
      var shipDate = new Date(today.setDate(today.getDate() + daysAfterToday));
      var options = { weekday: 'short', month: 'long', day: 'numeric' };
      var formattedDate = shipDate.toLocaleDateString('en-US', options);
      var flagImage = getCurrentCountrySRC();
      
      
      document.querySelectorAll('.country-flag-shipping').forEach(function (el) {
        var existingImg = el.querySelector('img');
        if (existingImg) el.removeChild(existingImg);
      
        var img = document.createElement('img');
        img.src = flagImage;
        img.alt = 'Country flag';
        el.prepend(img);
      });
      
      // document.querySelectorAll('.shipping-date').forEach(function (el) { 
      //   el.textContent = formattedDate;
      // });
    }
    
    var vectorsForSpakrling = {
        'default': function(options) {
            var size = options.size;
            return '<svg class="disable-fill-color" width="' + size + '" height="' + size + '" viewBox="0 0 68 68" fill="none"><path d="M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z" fill="currentColor" /></svg>';
        },
        'teddy': function() {
            return '<span>🐻</span>';
        },
        'pumpkin': function() {
            return '<span>🎃</span>';
        },
        'christmas-tree': function() {
            return '<span>🎄</span>';
        },
        'gift-box': function() {
            return '<span>🎁</span>';
        },
        "heart-bag-charm": function (options) {
          var size = options.size;

          return `<img src='https://cdn.shopify.com/s/files/1/0763/6169/5558/files/heart.png?v=1720810348' style="width: ${size}px; height: ${size}px" />`;
        },
        "susuwatari-bag-charm": function (options) {
          var size = options.size;

          return `<img src='https://cdn.shopify.com/s/files/1/0763/6169/5558/files/Photoroom_20240712_231631_8eb1f838-0773-450f-a7ae-5f20464f3491.png?v=1720852281' style="width: ${size}px; height: ${size}px" />`;
        },
        "schnauzer-bag-charm": function (options) {
          var size = options.size;

          return `<img src='https://cdn.shopify.com/s/files/1/0763/6169/5558/files/Photoroom_20240712_231519_48d42c56-81b3-4d2f-92e2-4585c3ced241.png?v=1720852348' style="width: ${size}px; height: ${size}px" />`;
        },
        "mr.bean-teddy-bag-charm": function (options) {
            return '<span>🐻</span>';
        },
    };

    function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function initSparkling() {
        var color = "#FFC700";
        var svgPath = '';

        function sparkling() {
            var sparklingElements = document.querySelectorAll('.sparkling');
            var productElement = document.querySelector('.product');
            var productName;
            if (productElement) {
              productName = productElement.getAttribute('data-name');
            }
            
            Array.prototype.forEach.call(sparklingElements, function(sparklingElement) {
                var stars = sparklingElement.getElementsByClassName('star');
                var isTouch = document.documentElement.classList.contains('touch');

                // if ((isTouch && !sparklingElement.classList.contains('sparkling-touch')) ||
                //     (!isTouch && sparklingElement.classList.contains('sparkling-touch'))) {
                //     return;
                // }

                if (stars.length > 5) {
                    sparklingElement.removeChild(stars[0]);
                }

                var vector = sparklingElement.getAttribute('data-vector') || productName || 'default';
                sparklingElement.insertAdjacentHTML('beforeend', addStar({ vector: vector }));
            });

            setTimeout(sparkling, random(300, 1700));
        }

        function addStar(options) {
            var vector = options.vector;
            var size = random(8, 30);
            var top = random(-50, 50);
            var left = random(0, 100);

            return '<span class="star" style="top:' + top + '%; left:' + left + '%;">' + (vectorsForSpakrling[vector] ? vectorsForSpakrling[vector]({ size: size }) : vectorsForSpakrling['default']({ size: size })) + '</span>';
        }

        sparkling();
    }

    // function handleColorSwatchesVariantsExternalLink() {
    //   const options = document.querySelectorAll('.label-only-input[data-external-url]:not([data-handled-location-changer=true])');

    //   if (!options) {
    //     return;
    //   }
      
    //   for (let i = 0; i < options.length; i++) {
    //     if (options[i].dataset.externalUrl) {
    //       options[i].setAttribute('data-handled-location-changer', 'true');
          
    //       options[i].addEventListener("click", function() {
    //         window.location.href = options[i].dataset.externalUrl;
    //       });
    //     }
    //   }
    // }

    function getCurrentCountrySRC() {
      var currentCountryCode = getCurrentCountryCode();
      
      if (!currentCountryCode) {
        return;
      }
      
      return "https://flagsapi.com/" + currentCountryCode + "/flat/64.png";
    }

    var headerCountryInterval;
  
    function handleCountryHeader() {
      var annbar = document.querySelector('.essential_countdown_annoucement_bar_wrapper p:last-child');

      if (!annbar) {
        clearInterval(headerCountryInterval);
        
        return;
      }

      if (annbar.querySelector('.country-flag')) {
        clearInterval(headerCountryInterval);
        
        return;
      }
      
      var wrapper = document.createElement('span');
      wrapper.className = 'country-flag';
    
      var img = document.createElement('img');
      img.src = getCurrentCountrySRC();
    
      wrapper.appendChild(img);

      // var currentCountry = document.documentElement.dataset.country;
      var currentCountryCode = getCurrentCountryCode();
      var text = document.createTextNode(" " + currentCountryCode.toUpperCase() + " ");

      annbar.appendChild(text);
      annbar.appendChild(wrapper);
    }

    function autoScrollToAncher() {
      document.querySelectorAll('.auto-scroll-to-page').forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          const targetId = element.dataset.target || element.getAttribute('href');
    
          if (targetId) {
            const targetElement = document.querySelector(targetId);

            
            if (targetElement && typeof targetElement.scrollIntoView === 'function') {
              targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        });
      });
    }

    function handlePaymentMeethodsListInCardDrawer() {
      const paymentList = document.querySelector(".payment-methods-list");
      const checkoutFooter = document.querySelector(".qsc2-drawer-footer__checkout");

      if (paymentList && checkoutFooter) {
        // clone the element (true = deep clone with children)
        const clone = paymentList.cloneNode(true);
        clone.classList.add('mt-2');

        // insert right after the checkout footer
        checkoutFooter.insertAdjacentElement("afterend", clone);
      }
    }

    function init() {
      initSparkling();
      addShippingTime();
      // handleColorSwatchesVariantsExternalLink();
      autoScrollToAncher();
      
      // setTimeout(() => {
      //   handlePaymentMeethodsListInCardDrawer();
      // }, 1000);

      headerCountryInterval = setInterval(function () {
        handleCountryHeader();
      }, 1500);
    }

    // window.handleColorSwatchesVariantsExternalLink = handleColorSwatchesVariantsExternalLink;
    

    if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
        init();
      
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }

})();


(function () {
    window.Shopify = window.Shopify || {};
    
    // Shopify.scaHandleConfigValue = {
    //   "bogos_progressing_bar_query": '.bogos_progressing_bar_query',
    //   "bogos_custom_progress_position": 'before',
    // }
  
    // document.addEventListener("fg-gifts:updated", async () => {
    //   let sca_cart = await fetch('/cart.js').then(async(scaCart) => {
    //     return await scaCart.json();
    //   });

    //   await fetch("/?sections=cart-items,cart-footer,cart-item-count").then(async(scaSection) => {
    //     sca_cart["sections"] = await scaSection.json();
    //   });
      
    //   document.body.dispatchEvent(
    //         new CustomEvent("baseline:cart:afteradditem", {
    //           bubbles: true,
    //           detail: {
    //             response: sca_cart
    //           }
    //         })
    //   );
    // });
  
  
    document.addEventListener('alpine:init', function () {
      if (!window.__AnnounceBarDefined) {
        window.__AnnounceBarDefined = true;

        Alpine.data('AnnounceBar', function (sid) {
          return {
            _sid: sid,
            _wrap: null,
            _ro: null,
            
            setVar(px) {
              document.documentElement.style.setProperty('--announcement-bar-height', px + 'px');
            },
            
            measure() {
              var el = this._wrap || document.getElementById('shopify-section-' + this._sid);
              if (!el) { this.setVar(0); return; }
              
              // Measure the inner section if present, else the wrapper
              var target = el.querySelector('#section-' + this._sid) || el;
              var rect = target.getBoundingClientRect();
              var h = Math.max(0, Math.round(rect.height));
              this.setVar(h);
            },
            
            init() {
              this._wrap = document.getElementById('shopify-section-' + this._sid);
              this.measure();
              
              var self = this;
              // Track size changes
              if ('ResizeObserver' in window) {
                this._ro = new ResizeObserver(function () { self.measure(); });
                if (this._wrap) this._ro.observe(this._wrap);
              }
              
              // Recalculate on viewport changes
              window.addEventListener('resize', this.measure.bind(this));
              
              // Recalculate after fonts load (height can change)
              if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(function(){ self.measure(); });
              }
            },
            
            destroy() {
              if (this._ro) { this._ro.disconnect(); this._ro = null; }
              window.removeEventListener('resize', this.measure);
            }
          };
        });
      }

      if (!window.__GiftWrap) {
        window.__GiftWrap = true;
        
        // GiftWrap relocated to assets/global.bundle.js (Alpine2.data("GiftWrap")) and hardened
        // there (r.ok guard so a 429/Cloudflare HTML page is never parsed as JSON; 429 retry-once;
        // revert-to-real-state on failure). SowAdd stays below (still under this guard).

        // SowAdd — one-tap add for special-offer cart suggestions (single-variant
        // products). Mirrors GiftWrap.addGift: POSTs to the theme's own cart-add and
        // dispatches the same refresh event. Used because the Add button lives inside
        // <form id="cart">, where a product <form> cannot be nested.
        Alpine.data('SowAdd', function () {
          return {
            adding: false,
            sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            add: function () {
              if (this.adding) return;
              // Read the variant id FRESH from the DOM at click time — NOT a captured
              // closure arg. Alpine.morph re-renders the suggestion carousel and can
              // reuse a button's component instance for a DIFFERENT product after the
              // list reorders/filters; a captured variantId would then add the wrong
              // item. The morph updates data-variant-id, so reading it here always
              // adds the product the button visibly shows.
              var variantId = parseInt(this.$el.dataset.variantId, 10);
              if (!variantId) return;
              this.adding = true;
              var self = this;
              fetch(theme.routes.cart_add_url, {
                method: 'POST',
                headers: self.headers,
                body: JSON.stringify({
                  id: variantId,
                  quantity: 1,
                  sections: self.sections,
                  sections_url: window.location.pathname
                })
              })
              .then(function (r) { return r.json(); })
              .then(function (data) {
                if (data && data.status) return;
                var d = { response: data, sourceId: 'sow-add' };
                var evt;
                try { evt = new CustomEvent('baseline:cart:afteradditem', { bubbles: true, detail: d }); }
                catch (e) { evt = document.createEvent('CustomEvent'); evt.initCustomEvent('baseline:cart:afteradditem', true, false, d); }
                document.body.dispatchEvent(evt);
              })
              .catch(function (e) { console.error(e); })
              .then(function () { self.adding = false; });
            }
          };
        });
      }
    });

    // ── Live-update the PDP offer widget on any cart change ──
    // The widget is server-rendered (reads the cart at page load). On add / qty
    // change, re-render it via the Section Rendering API (?section_id=…) and swap
    // it in, so progress, count, and filtered suggestions reflect the live cart.
    function sowPdpSync() {
      var widgets = document.querySelectorAll('[data-sopdp-section]');
      if (!widgets.length) return;
      widgets.forEach(function (el) {
        var sid = el.getAttribute('data-sopdp-section');
        fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('sopdp-' + sid);
            var cur = document.getElementById('sopdp-' + sid);
            if (fresh && cur) { cur.replaceWith(fresh); }
          })
          .catch(function (e) { console.error(e); });
      });
    }
    window.addEventListener('baseline:cart:afteradditem', sowPdpSync);
    window.addEventListener('baseline:cart:cartqtychange', sowPdpSync);
    window.addEventListener('baseline:cart:update', sowPdpSync);
}());